import React from 'react';
import PropTypes from 'prop-types';
import { Components } from 'versafleet-core';
import Logo from './logo';

const LoginLoading = ({ text = null }) => (
  <div className="vf-authentication__login-loading">
    <Logo className="vf-authentication__login-loading__logo" isLoadingScreen />
    {
      text
        ? (
          <div className="vf-authentication__login-loading__text">
            {text}
          </div>
        ) : false
    }
    <Components.EllipsisLoading className="vf-authentication__login-loading__ellipsis" />
  </div>
);

LoginLoading.displayName = 'Login Loading';

LoginLoading.propTypes = {
  text: PropTypes.string,
};

export default (LoginLoading);
